import { IPublicClientApplication } from '@azure/msal-browser';
import { DocumentGroupTypeCode, ProgramDocumentRequest } from '../../models';
import { ApiEndpointCallStatesStore } from '../api-endpoint-call-states-store';
import { FetchContext } from '../fetch-context';
import { promiseWithObservableState } from '../promise-with-observable-state';
import { withApiAccessToken } from '../with-api-access-token';
import {
  createProgramDocument,
  deleteProgramDocument,
  getStaffProgramDocuments,
  updateProgramDocument,
  uploadProgramDocumentContent,
} from './index';

export const createStaffProgramDocumentsApiEndpoints = (
  fetchContext: FetchContext,
  apiEndpointCallStates: ApiEndpointCallStatesStore,
) => ({
  getStaffProgramDocuments: (instance: IPublicClientApplication, documentGroupTypeCode: DocumentGroupTypeCode) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => getStaffProgramDocuments(fetchContext, documentGroupTypeCode, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('getStaffProgramDocuments', isInFlight);
    },
  ),
  createProgramDocument: (instance: IPublicClientApplication, programDocument: ProgramDocumentRequest) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => createProgramDocument(fetchContext, programDocument, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('createProgramDocument', isInFlight);
    },
  ),
  updateProgramDocument: (instance: IPublicClientApplication, programDocumentId: number, programDocument: ProgramDocumentRequest) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => updateProgramDocument(fetchContext, programDocumentId, programDocument, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('updateProgramDocument', isInFlight);
    },
  ),
  uploadProgramDocumentContent: (instance: IPublicClientApplication, file: File) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => uploadProgramDocumentContent(fetchContext, file, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('uploadProgramDocumentContent', isInFlight);
    },
  ),
  deleteProgramDocument: (instance: IPublicClientApplication, programDocumentId: number) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => deleteProgramDocument(fetchContext, programDocumentId, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('deleteProgramDocument', isInFlight);
    },
  ),
});
